export default __webpack_public_path__ + "static/media/Foma-Home-Logo.1878d3b6.jpg";